import { useCallback, useEffect, useState } from 'react';

import { erc20Abi } from 'viem';
import { useReadContract, type UseReadContractParameters } from 'wagmi';

import { EvmContractAddress } from '@/types';

const useReadERC20Balance = (walletAddress: EvmContractAddress) => {
  const [contract, setContract] = useState<UseReadContractParameters>();

  const constructContractRead = useCallback(
    (erc20TokenContract: EvmContractAddress, chainId?: number): UseReadContractParameters => {
      return {
        abi: erc20Abi,
        functionName: 'balanceOf',
        address: erc20TokenContract,
        args: [walletAddress],
        chainId,
        query: {
          enabled: Boolean(walletAddress) && Boolean(erc20TokenContract),
          refetchInterval: 10 * 1000,
          refetchOnMount: true,
          refetchOnWindowFocus: true,
        },
      };
    },
    [walletAddress]
  );

  useEffect(() => {
    if (contract?.address) {
      setContract(constructContractRead(contract.address));
    }
  }, [walletAddress]);

  const result = useReadContract(contract);

  return {
    ...result,
    contract,
    getBalance: useCallback(
      (erc20TokenContract: EvmContractAddress, chainId?: number) => {
        if (erc20TokenContract) {
          setContract(constructContractRead(erc20TokenContract, chainId));
        }
      },
      [constructContractRead]
    ),
  };
};

export default useReadERC20Balance;
